import { Mail, MapPin, Phone, SendIcon } from "lucide-react";
import { useState } from "react";

import { Button } from "@krea/shared/design-system/Button";
import { KreaLogo } from "@krea/shared/design-system/logo/krea";
import { AppModal } from "@krea/shared/design-system/modal";
import { Separator } from "@krea/shared/design-system/Separator";
import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
} from "@krea/shared/design-system/sidebar";

interface IProps {
  className?: string;
}

export const NavSecondary = ({ className }: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <SidebarGroup className={className}>
      <SidebarGroupContent>
        <SidebarMenu>
          <SidebarMenuButton
            asChild
            size="sm"
            onClick={() => setIsOpen(true)}
            className="cursor-pointer"
          >
            <div className="flex items-center gap-2">
              <SendIcon />
              <span>Contact & Feedback</span>
            </div>
          </SidebarMenuButton>
          <AppModal
            open={isOpen}
            setOpen={setIsOpen}
            lockOutsideInteraction={false}
            hideCloseButton={true}
            title="Contact & Feedback"
          >
            <div className="max-h-[70vh] overflow-y-auto">
              <div className="space-y-6">
                {/* Company info */}
                <div className="rounded-lg bg-primary-150 p-5">
                  <div className="flex items-center gap-3">
                    <KreaLogo />
                    <div>
                      <h3 className="text-subsection">Krea Technology AB</h3>
                      <p className="m-0 text-helper">Org.nr: 559173-2895</p>
                    </div>
                  </div>
                </div>

                {/* Contact details */}
                <div className="space-y-2">
                  <h3 className="text-subsection">Contact Us</h3>

                  <div className="space-y-3">
                    {/* Phone */}
                    <div className="flex items-start gap-3">
                      <div className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary-150">
                        <Phone
                          className="h-4 w-4 text-primary"
                          strokeWidth={2.5}
                        />
                      </div>
                      <div className="flex-1">
                        <p className="mb-1 text-label">Phone</p>
                        <p className="mb-2 text-base-strong">08-551 082 62</p>
                      </div>
                      <Button>
                        <a
                          href="tel:0855108262"
                          className="flex items-center gap-2 font-semibold text-white"
                        >
                          <Phone strokeWidth={2.5} className="h-4 w-4" />
                          <span>Call Now</span>
                        </a>
                      </Button>
                    </div>

                    <Separator className="my-2" />

                    {/* Email */}
                    <div className="flex items-start gap-3">
                      <div className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary-150">
                        <Mail
                          className="h-4 w-4 text-primary"
                          strokeWidth={2.5}
                        />
                      </div>
                      <div className="flex-1">
                        <p className="mb-1 text-label">E-mail</p>
                        <p className="mb-2 break-all text-base-strong">
                          kundservice@krea.se
                        </p>
                      </div>
                      <Button>
                        <a
                          href="mailto:kundservice@krea.se"
                          className="flex items-center gap-2 font-semibold text-white"
                        >
                          <Mail className="h-4 w-4" />
                          <span>Send Email</span>
                        </a>
                      </Button>
                    </div>

                    <Separator className="my-2" />

                    {/* Address */}
                    <div className="flex items-start gap-3">
                      <div className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary-150">
                        <MapPin
                          className="h-4 w-4 text-primary"
                          strokeWidth={2.5}
                        />
                      </div>
                      <div className="flex-1">
                        <p className="mb-1 text-label">Address</p>
                        <p className="m-0 text-base-strong">Valhallavägen 60</p>
                        <p className="m-0 text-base-strong">114 27 Stockholm</p>
                      </div>
                      <Button>
                        <a
                          href="https://maps.app.goo.gl/D3wtGCxe1zuYxW4eA"
                          className="flex items-center gap-2 font-semibold text-white"
                        >
                          <MapPin className="h-4 w-4" />
                          <span>Visit us</span>
                        </a>
                      </Button>
                    </div>
                  </div>
                </div>

                {/* Opening hours */}
                <div className="space-y-2">
                  <h3 className="text-subsection">Opening Hours</h3>

                  <div className="space-y-2.5 rounded-lg bg-primary-150 p-4">
                    <div className="flex items-center justify-between">
                      <span className="text-base">Monday - Thursday:</span>
                      <span className="text-base-strong">09 - 18</span>
                    </div>
                    <div className="flex items-center justify-between">
                      <span className="text-base">Friday:</span>
                      <span className="text-base-strong">09 - 17</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </AppModal>
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
};
